import { BrowserRouter } from "react-router-dom";
import AppRouter from "./router/AppRouter";
import "./App.css";
import "./assets/css/common.css";
import "./assets/css/form.css";
import "./assets/css/fuck-you-the-terrible-designer-style.css";

function App() {
  const basename =
    (typeof process.env.PUBLIC_URL === "string" && process.env.PUBLIC_URL) ||
    "/";
  return (
    <BrowserRouter basename={basename}>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
